import { render, staticRenderFns } from "./RIForm.vue?vue&type=template&id=aca033b6&"
import script from "./RIForm.vue?vue&type=script&lang=js&"
export * from "./RIForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports